import { functions } from "../firebase";

export type ThreadsConnection = {
  connected: boolean;
  username?: string;
  scopes?: string[];
  stale?: boolean;
  staleReason?: string | null;
};

export const getThreadsConnection = async (
  communityId: string
): Promise<ThreadsConnection> => {
  const callable = functions.httpsCallable("threadsGetConnection");
  const res = await callable({ communityId });
  return res.data as ThreadsConnection;
};

export const startThreadsAuth = async (
  communityId: string
): Promise<{ url: string }> => {
  const callable = functions.httpsCallable("threadsStartAuth");
  const res = await callable({ communityId });
  return res.data as { url: string };
};

export const completeThreadsAuth = async (params: {
  code: string;
  state: string;
}): Promise<ThreadsConnection> => {
  const callable = functions.httpsCallable("threadsCompleteAuth");
  const res = await callable(params);
  return res.data as ThreadsConnection;
};

export const disconnectThreads = async (
  communityId: string
): Promise<{ connected: boolean }> => {
  const callable = functions.httpsCallable("threadsDisconnect");
  const res = await callable({ communityId });
  return res.data as { connected: boolean };
};
